import React from 'react';

const number = (value) => (Number.isFinite(value) ? value.toLocaleString('fr-FR') : '—');

const CategoryQuotaDetails = ({ category, className = '' }) => {
  const isComplete = Number.isFinite(category.available) && category.available <= 0;

  return (
    <div className={className}>
      <p className="text-sm font-semibold">
        {category.name} {isComplete && <span className="ml-1 text-xs text-red-700">Complet</span>}
      </p>
      <p className="mt-1 text-[13px] text-slate-500">
        <strong className="text-slate-700">{number(category.occupied)}</strong> occupées ·{' '}
        {Number.isFinite(category.available) ? (
          <>
            <strong className="text-emerald-800">{number(category.available)}</strong> disponibles /{' '}
            {number(category.total)}
          </>
        ) : (
          <strong className="text-slate-700">Disponibilité indisponible</strong>
        )}
        {category.sharedQuota && <span> · quota partagé de {number(category.total)} places</span>}
      </p>
    </div>
  );
};

export default CategoryQuotaDetails;
